import { profile } from "../data/profile";

export const Footer = () => (
  <footer className="bg-navy text-bone">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <span className="h-12 w-12 rounded-md bg-navy flex items-center justify-center p-1.5 ring-1 ring-gold/40">
              <img src="/assets/vp-gold.png" alt="VP" className="w-full h-full object-contain" />
            </span>
            <span>
              <span className="block font-display text-lg font-bold">{profile.shortName}</span>
              <span className="block text-[0.65rem] font-plex uppercase tracking-[0.18em] text-gold">
                Healthcare Professional
              </span>
            </span>
          </div>
          <p className="mt-5 text-sm text-bone/70 max-w-xs leading-relaxed">
            {profile.qualifications}
          </p>
        </div>

        <div>
          <h4 className="font-plex text-xs uppercase tracking-widest text-gold">Contact</h4>
          <ul className="mt-4 space-y-2 text-sm text-bone/80">
            <li>
              <a href={`mailto:${profile.contact.email}`} className="hover:text-gold transition-colors break-all" data-testid="footer-email">
                {profile.contact.email}
              </a>
            </li>
            <li>
              <a href={profile.contact.linkedin} target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-testid="footer-linkedin">
                LinkedIn — Dr. Vijay Pandya
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-plex text-xs uppercase tracking-widest text-gold">Explore</h4>
          <ul className="mt-4 space-y-2 text-sm text-bone/80">
            {["about", "expertise", "experience", "awards", "achievements", "services", "contact"].map((id) => (
              <li key={id}>
                <button
                  data-testid={`footer-link-${id}`}
                  onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })}
                  className="capitalize hover:text-gold transition-colors"
                >
                  {id}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-bone/60">
          © {new Date().getFullYear()} {profile.name}. All rights reserved.
        </p>
        <p className="text-xs text-bone/60 font-plex">NABH Assessor · Quality Council of India Member</p>
      </div>
    </div>
  </footer>
);
